module.exports = __webpack_public_path__ + "img/the secret god of the sky.3ec8f167.png";